
import BaseEvent from "./BaseEvent";

export default class AppEvent extends BaseEvent{

    static GENERATED_911_TRANSFER_NUM:string = "generated911TransferNum";
    static VIEW_CDR_DETAILS:string = "viewCDRDetails";
    static GOT_CONTACT_NUMBER:string = "gotContactNumber";
    static FORCE_LOGOUT:string = "forceLogout";
    static GOT_EMAIL:string = "gotEmail";
    static VIEW_USER_DETAILS:string = "viewUserDetails";
    static GOT_CALLBACK_NUMBER:string = "gotCallBackNumber";
}